<table datatable class="table table-striped table-bordered bg-white align-middle">
	<thead>
		<tr>
			<th class="text-left">{{'Value' | translate}}</th>
			<th>{{'Case sensitive' | translate}}</th>
			<th>{{'Exact match' | translate}}</th>
			<th>{{'Word match' | translate}}</th>
			<th></th>
		</tr>
	</thead>
	<tbody
		cdkDropList
		[cdkDropListData]="dynamicValidation?.blacklistRows"
		(cdkDropListDropped)="dropped($event)">
		<tr cdkDrag *ngFor="let item of dynamicValidation?.blacklistRows; let i = index">
			<td>
				<div>
					<input class="form-control"
						   type="text"
						   name="blacklist-value"
						   [(ngModel)]="item.value"
						   [rangeLength]="[2, 256]"
						   (blur)="save()"
						   (focus)="disableSave()"
						   placeholder="{{ 'Value' | translate }}"
						   style="border-top-right-radius:0;border-bottom-right-radius:0;"
						   required />
				</div>
			</td>
			<td class="text-center">
				<div class="form-group mt-0">
					<label class="ui-checkbox input-label no-text">
						<input class="form-control" name="caseSensitive" type="checkbox" value="{{item.caseSensitive}}"
							   (change)="save()" [(ngModel)]="item.caseSensitive">
						<span></span>
					</label>
				</div>
			</td>
			<td class="text-center">
				<div class="form-group mt-0">
					<label class="ui-checkbox input-label no-text">
						<input class="form-control" name="exactMatch" type="checkbox" value="{{item.exactMatch}}"
							   (change)="exactMatchChanged(item); save()" [(ngModel)]="item.exactMatch">
						<span></span>
					</label>
				</div>
			</td>
			<td class="text-center">
				<div class="form-group mt-0">
					<label class="ui-checkbox input-label no-text">
						<input class="form-control" name="wordMatch" type="checkbox" value="{{item.wordMatch}}"
							   (change)="wordMatchChanged(item); save()" [(ngModel)]="item.wordMatch">
						<span></span>
					</label>
				</div>
			</td>
			<td class="text-center">
				<i class="fas fa-times btn-xs btn-bordered btn-danger btn-icon false" (click)="deleteRow(i)"></i>
			</td>
		</tr>
		<tr>
			<td>
				<div>
					<input class="form-control"
						   type="text"
						   name="blacklist-value"
						   [(ngModel)]="newRow.value"
						   [rangeLength]="[2, 256]"
						   placeholder="{{ 'Value' | translate }}"
						   style="border-top-right-radius:0;border-bottom-right-radius:0;"
						   required />
				</div>
			</td>
			<td class="text-center">
				<div class="form-group mt-0">
					<label class="ui-checkbox input-label no-text">
						<input class="form-control" name="caseSensitive" type="checkbox" value="{{newRow.caseSensitive}}"
							   [(ngModel)]="newRow.caseSensitive">
						<span></span>
					</label>
				</div>
			</td>
			<td class="text-center">
				<div class="form-group mt-0">
					<label class="ui-checkbox input-label no-text">
						<input class="form-control" name="exactMatch" type="checkbox" value="{{newRow.exactMatch}}"
							   (change)="exactMatchChanged(newRow)"
							   [(ngModel)]="newRow.exactMatch">
						<span></span>
					</label>
				</div>
			</td>
			<td class="text-center">
				<div class="form-group mt-0">
					<label class="ui-checkbox input-label no-text">
						<input class="form-control" name="wordMatch" type="checkbox" value="{{newRow.wordMatch}}"
							   (change)="wordMatchChanged(newRow)"
							   [(ngModel)]="newRow.wordMatch">
						<span></span>
					</label>
				</div>
			</td>

			<td class="text-center">
				<button class="btn btn-outline-primary" type="button"
					(click)="addNewRow()" [hidden]="isAddButtonDisabled()">{{'Add' | translate}}</button>
				<span class="error text-danger" *ngIf="!isAddButtonDisabled()">
					{{ 'Dont forget!' | translate }}
				</span>
			</td>
		</tr>
	</tbody>
</table>
